module.exports = {
	methods: {
		getPrefectures: function(value){
			// var prefectures = this.$root.prefectures;
			var prefecture = this.prefecturesList;
			for (var i = 0; i < prefecture.length; i++){
				if ((value - 1) === i){
					return prefecture[i];
				}
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/mixins/getPrefectures.js